"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_QUICK_CHECKOUT_PATH = exports.WIDGET_ENDPOINTS = exports.TREATMENTS = exports.SOURCE = exports.SHOPIFY_PLACEHOLDER_CUSTOMER_ID = exports.SESSION_STORAGE_VALUES = exports.SESSION_STORAGE_KEYS = exports.QUICK_CHECKOUT_SELECT_ANOTHER_ADDRESS_ID = exports.QUERY_PARAMS = exports.MERCHANT_CONFIG_JS = exports.MERCHANT_CONFIG_CSS = exports.INR = exports.IFRAME_TAG_NAME = exports.IFRAME_IDS = exports.EXPERIMENT_IDS = exports.EVENT_TYPE = exports.EMBEDDED_CHECKOUT_IMPORT_ADDRESS_WIDGET_ID = exports.ECP = exports.DEFAULT_QUANTITY = exports.CSS_CLASSES = exports.CSS = exports.CHECKOUT_BUTTON_WITH_ADDRESS_PREFILL_ID = exports.CHECKOUT_BUTTON_TYPE = exports.BWA_WIDGET_CONTAINER_IDS = exports.BWA_SESSION_HEADER = exports.BWA_ENDPOINT = exports.BUTTON_NAMES = exports.API_ENDPOINTS = void 0;
var BWA_ENDPOINT = exports.BWA_ENDPOINT = "https://buywithamazon.amazon.in";
var ECP = exports.ECP = "SHOPIFY";
var INR = exports.INR = "INR";
var SHOPIFY_PLACEHOLDER_CUSTOMER_ID = exports.SHOPIFY_PLACEHOLDER_CUSTOMER_ID = "ShopifyCustomer";
var WIDGET_QUICK_CHECKOUT_PATH = exports.WIDGET_QUICK_CHECKOUT_PATH = "/widget/quick-checkout";
var MERCHANT_CONFIG_JS = exports.MERCHANT_CONFIG_JS = "merchant-config.js";
var MERCHANT_CONFIG_CSS = exports.MERCHANT_CONFIG_CSS = "merchant-config.css";
var DEFAULT_QUANTITY = exports.DEFAULT_QUANTITY = 1;
var WIDGET_ENDPOINTS = exports.WIDGET_ENDPOINTS = {
  CHECKOUT_BUTTON: "".concat(BWA_ENDPOINT, "/widget/v2/bwa-checkout-button?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  DELIVERY_PILL: "".concat(BWA_ENDPOINT, "/v2/widget/bwa-delivery-promise?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  DELIVERY_BLOCK: "".concat(BWA_ENDPOINT, "/widget/bwa-delivery-block?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  INPUT_PINCODE: "".concat(BWA_ENDPOINT, "/widget/bwa-input-pincode?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  LOADER: "".concat(BWA_ENDPOINT, "/widget/loader?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  POWERED_BY_AMAZON: "".concat(BWA_ENDPOINT, "/widgets/powered-by-amazon?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  INFO: "".concat(BWA_ENDPOINT, "/v3/widgets/info?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  CHECKOUT_BUTTON_WITH_ADDRESS_PREFILL: "".concat(BWA_ENDPOINT, "/widget/v2/bwa-checkout-button?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId, "&variant=import_address"),
  CHECKOUT_BUTTON_WITHOUT_ADDRESS_PREFILL: "".concat(BWA_ENDPOINT, "/widget/v2/bwa-checkout-button?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId, "&mode=without_address_prefill"),
  CHECKOUT_ADDRESS_FILL_SELECTION: "".concat(BWA_ENDPOINT, "/widget/v2/bwa-checkout-button?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId, "&variant=optional_address_selection"),
  REDIRECT_INFO: "".concat(BWA_ENDPOINT, "/widget/bwa-redirect-info?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  EMPTY_WIDGET: "".concat(BWA_ENDPOINT, "/widget/bwa-empty?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  CHECKOUT_PAGE: "".concat(BWA_ENDPOINT, "/checkout-page?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId),
  CHECKOUT_LOADER: "".concat(BWA_ENDPOINT, "/checkout-loader?ecp=").concat(ECP, "&ecpShopId=").concat(window.storeId)
};
var API_ENDPOINTS = exports.API_ENDPOINTS = {
  fetchPromiseV2: function fetchPromiseV2(storeId) {
    return "".concat(BWA_ENDPOINT, "/v2/data/fetch-promise?ecp=").concat(ECP, "&ecpShopId=").concat(storeId);
  },
  validateStore: function validateStore(storeId) {
    return "".concat(BWA_ENDPOINT, "/v3/validate/store/").concat(ECP, "/").concat(storeId, "?ecp=").concat(ECP, "&ecpShopId=").concat(storeId);
  },
  validateSku: function validateSku(storeId, variantId) {
    return "".concat(BWA_ENDPOINT, "/validate/sku/").concat(ECP, "/").concat(storeId, "/").concat(variantId, "?ecp=").concat(ECP, "&ecpShopId=").concat(storeId, "&ecpSkuId=").concat(variantId);
  },
  katalLogger: "".concat(BWA_ENDPOINT, "/prod/v1/log")
};
var EVENT_TYPE = exports.EVENT_TYPE = {
  CHANGE: "change",
  MESSAGE: "message",
  CLICK: "click",
  VISIBILITY_CHANGE: "visibilitychange",
  CUSTOM: {
    BWA_CLEAR_DELIVERY_PILLS: "bwa-cart:clear-delivery-pills",
    BWA_DELIVERY_PILL_IFRAME_READY: "bwa-delivery-pill-iframe-ready",
    CART_UPDATED: "cart:updated",
    VARIANT_UPDATED: "variant:updated",
    PRODUCT_RATINGS_RENDER: "product-ratings:render",
    PRODUCT_REVIEWS_RENDER: "product-reviews:render",
    CHECKOUT_BUTTON_CLICKED: "checkout-button-clicked",
    RESOLVE_CHECKOUT_OPTIONS: "bwa-cart:resolve-checkout-options",
    SETUP_RETRY_UPDATE_DELIVERY_PILL: "bwa-cart:setup-retry-update-delivery-pills",
    SHOW_CHECKOUT_OPTIONS: "bwa-cart:show-checkout-options",
    UPDATE_DELIVERY_PILL: "bwa-cart:update-delivery-pills",
    BWA_PRODUCT_VIEWED: "bwa-product:viewed",
    BWA_CHECKOUT_BUTTON_RENDER: "bwa-checkout-button:render",
    BWA_CHECKOUT_BUTTON_SUBMIT: "bwa-checkout-button:submit",
    BWA_DELIVERY_BLOCK_IFRAME_RENDER: "bwa-delivery-block-iframe:render",
    BWA_DELIVERY_BLOCK_EDIT_CLICKED: "bwa-delivery-block-edit-clicked",
    BWA_DELIVERY_BLOCK_RENDERED: "bwa-delivery-block-rendered",
    BWA_DELIVERY_BLOCK_POPUP_OPENED: "bwa-delivery-block-popup-opened",
    BWA_DELIVERY_BLOCK_POPUP_CLOSED: "bwa-delivery-block-popup-closed",
    BWA_REDIRECT_INFO_RENDERED: "bwa-redirect-info-rendered",
    BWA_CHECKOUT_FAILED: "bwa-checkout-failed",
    BWA_PINCODE_MODAL_CLOSED: "bwa-pincode-modal-closed",
    BWA_PINCODE_APPLIED: "bwa-pincode-applied",
    NATIVE_ADD_TO_CART_BUTTON_SUBMIT: "native-add-to-cart-button:submit",
    OTHER_CHECKOUT_BUTTON_SUBMIT: "other-checkout-button:submit",
    BWA_CHECKOUT_INTERSTITIAL_LOADER_RENDER: "bwa-checkout-interstitial-loader:render",
    BWA_POWERED_BY_AMAZON_IFRAME_RENDER: "bwa-powered-by-amazon-iframe:render",
    BWA_POWERED_BY_AMAZON_RENDERED: "bwa-powered-by-amazon-rendered",
    BWA_POWERED_BY_AMAZON_INFO_BUTTON_CLICKED: "info-button-clicked",
    BWA_POWERED_BY_AMAZON_INFO_DIALOG_CLOSED: "info-dialog-closed",
    BWA_ADDRESS_CHECKOUT_SELECTION_DIALOG_CLOSED: "add-address-checkout-dialog-closed",
    BWA_CLICK_UPDATE_ADDRESS_PDP: "click-update-address-pdp",
    BWA_CLICK_APPLY_PINCODE_BUTTON: "click-apply-pincode-button",
    BWA_CLICK_POWERED_BY_AMAZON_INFO: "click-powered-by-amazon-info",
    CLICK_NATIVE_BUY_NOW_BUTTON: "click-native-buy-now-button",
    CLICK_NATIVE_CHECKOUT_BUTTON: "click-native-checkout-button",
    BWA_ADD_ADDRESS_CHECKOUT_BLOCK_RENDER: "bwa-add-address-checkout-block-render",
    BWA_APP_SWITCH_INITIATED: "bwa-app-switch-initiated",
    BWA_REDIRECT_ATTEMPT: "bwa-redirect-attempt",
    BWA_STORE_CIT: "bwa-store-cit",
    VIEW_BWA_CHECKOUT_SKU: "view-bwa-checkout-sku",
    BWA_CHECKOUT_CART_LOADED: "bwa-checkout-cart-loaded",
    BWA_REPEAT_CUSTOMER_RESOLVED: "bwa-repeat-customer-resolved",
    BWA_VALIDATE_CHECKOUT_V3_TRIGGER: "bwa-validate-checkout-v3-trigger",
    BWA_VALIDATE_CHECKOUT_V3_COMPLETE: "bwa-validate-checkout-v3-complete",
    BWA_QUICK_CHECKOUT_TRIGGER: "bwa-quick-checkout-trigger",
    BWA_QUICK_CHECKOUT_COMPLETE: "bwa-quick-checkout-complete",
    BWA_QUICK_CHECKOUT_DISMISS: "bwa-quick-checkout-dismiss",
    BWA_QUICK_CHECKOUT_RENDERED: "bwa-quick-checkout-rendered",
    // Embedded checkout. TRIGGER is dispatched locally to open the overlay;
    // COMPLETE/DISMISS are posted by the embedded checkout page iframe (must match server values).
    BWA_EMBEDDED_CHECKOUT_TRIGGER: "bwa-embedded-checkout-trigger",
    BWA_EMBEDDED_CHECKOUT_COMPLETE: "bwa-embedded-checkout-complete",
    BWA_EMBEDDED_CHECKOUT_DISMISS: "bwa-embedded-checkout-dismiss",
    BWA_EMBEDDED_CHECKOUT_BACK_INTENT: "bwa-embedded-checkout-back-intent",
    // Cart-only relay: ECP asks the same-origin checkout-button iframe to create the cart and
    // return { checkoutId, returnUrl } (no navigation). Must match the server widget's values.
    BWA_CART_CREATE_REQUEST: "bwa-cart-create-request",
    BWA_CART_CREATE_RESPONSE: "bwa-cart-create-response",
    // WebOTP relay (values must match cognitoLogin.js, which doesn't import this module).
    BWA_OTP_AUTOFILL_ARM: "bwa-otp-autofill-arm",
    BWA_OTP_AUTOFILL_CODE: "bwa-otp-autofill-code",
    BWA_OTP_AUTOFILL_CANCEL: "bwa-otp-autofill-cancel"
  }
};
var BWA_SESSION_HEADER = exports.BWA_SESSION_HEADER = 'X-Bwa-Session-Id';
var IFRAME_IDS = exports.IFRAME_IDS = {
  EMPTY_WIDGET: "bwa-empty-widget",
  QUICK_CHECKOUT: "bwa-quick-checkout-widget",
  EMBEDDED_CHECKOUT: "bwa-embedded-checkout-iframe"
};
var SESSION_STORAGE_KEYS = exports.SESSION_STORAGE_KEYS = {
  CLIENT_ID: "clientId",
  IS_BWA_SKU: "isBwASku",
  IS_PRODUCT_REVIEWS_ENABLED: "isProductReviewsEnabled",
  IS_PRODUCT_RATINGS_ENABLED: "isProductRatingsEnabled",
  IS_BWA_ATC: "isBwAATC",
  SKU_AVAILABILITY_DATA: "skuAvailabilityData",
  PINCODE: "pincode",
  LAST_CLICKED_BUTTON_TYPE: "lastClickedButtonType",
  BWA_GA_CLIENT_ID_KEY: "bwaGaClientId",
  RTO_TREATMENT: "bwaRtoTreatment",
  IS_BWA_REPEAT_CUSTOMER: "isBwARepeatCustomer",
  ECP_SESSION_ID: "ecpSessionId",
  IS_MSHOP_INSTALLED: "isMShopInstalled",
  COGNITO_LOGIN_TREATMENT: "bwaCognitoLoginTreatment",
  REVAMPED_ASP_TREATMENT: "bwaRevampedAspTreatment",
  /** Events-only: full validate-store `treatments` map (JSON string) used to enrich
   *  GA/Katal events. Behaviour gating keeps using the per-experiment keys above. */
  BWA_EVENT_EXPERIMENTS: "bwaEventExperiments",
  /** Events-only: BwA store id, read by the Shopify checkout pixel (BwAShopifyScripts) to
   *  stamp ecp_store_id on checkout events, which carry no BwA payload of their own. */
  BWA_STORE_ID: "bwaStoreId"
};
var SESSION_STORAGE_VALUES = exports.SESSION_STORAGE_VALUES = {
  TRUE: "true",
  FALSE: "false",
  BUY_NOW_BUTTON: "buy_now",
  CHECKOUT_BUTTON: "checkout_button"
};

// Experiments the client explicitly asks validate-store to resolve. Note `bwa-experience`
// (the overall experience cohort: bwa / bwa_none / bwa_checkout_none) is deliberately absent —
// Horizonte resolves it on every validate-store call and always returns it in `treatments`.
var EXPERIMENT_IDS = exports.EXPERIMENT_IDS = {
  RTO_CHECKOUT: "bwa-rto-checkout",
  // Cognito phone+OTP login experience (server-side experiment/mutant ids).
  COGNITO_LOGIN: "bwa-cognito-login",
  // Revamped ASP / embedded checkout page experience.
  REVAMPED_ASP: "bwa-revamped-asp"
};
var TREATMENTS = exports.TREATMENTS = {
  CONTROL: "C",
  T1: "T1",
  T2: "T2"
};
var BUTTON_NAMES = exports.BUTTON_NAMES = {
  CHECKOUT: "checkout",
  BUY_NOW: "buy now button"
};
var QUERY_PARAMS = exports.QUERY_PARAMS = {
  CHECKOUT_REDIRECT: "checkout_redirect",
  CHECKOUT_ID: "checkout_id",
  // Experience override. BwAUtmScript mirrors this URL param into sessionStorage under
  // the same key, so it survives in-session navigation.
  UTM_EXPERIENCE: "utm_experience"
};
var IFRAME_TAG_NAME = exports.IFRAME_TAG_NAME = "IFRAME";
var CSS_CLASSES = exports.CSS_CLASSES = {
  REDIRECT_INFO_WIDGET: "bwa-redirect-info-widget",
  EMPTY_WIDGET: "bwa-empty-widget",
  QUICK_CHECKOUT: "bwa-quick-checkout-widget",
  QUICK_CHECKOUT_CONTAINER: "bwa-quick-checkout-container",
  EMBEDDED_CHECKOUT: "bwa-embedded-checkout-widget",
  EMBEDDED_CHECKOUT_CONTAINER: "bwa-embedded-checkout-container"
};
var SOURCE = exports.SOURCE = {
  WEBSITE: "website"
};
var CSS = exports.CSS = {
  DISPLAY: {
    BLOCK: "block",
    NONE: "none"
  }
};
var BWA_WIDGET_CONTAINER_IDS = exports.BWA_WIDGET_CONTAINER_IDS = {
  BWA_ATC_BUTTON_CONTAINER_ID: "bwa-add-to-cart-button-container",
  BWA_RFA_REVIEWS_CONTAINER_ID: "amazon-product-reviews-container",
  BWA_RFA_RATING_CONTAINER_ID: "amazon-product-rating-container",
  BWA_RFA_SHORT_HAND_RATING_CONTAINER_ID: "amazon-product-short-hand-rating-container",
  BWA_DELIVERY_BLOCK_CONTAINER_ID: "bwa-delivery-block-container",
  BWA_POWERED_BY_AMAZON_CONTAINER_ID: "bwa-powered-by-amazon-container",
  BWA_QUICK_CHECKOUT_CONTAINER_ID: "bwa-quick-checkout-container",
  BWA_EMBEDDED_CHECKOUT_CONTAINER_ID: "bwa-embedded-checkout-container"
};
var CHECKOUT_BUTTON_TYPE = exports.CHECKOUT_BUTTON_TYPE = {
  WITH_ADDRESS_PREFILL: "with_address_prefill",
  WITHOUT_ADDRESS_PREFILL: "without_address_prefill"
};
var CHECKOUT_BUTTON_WITH_ADDRESS_PREFILL_ID = exports.CHECKOUT_BUTTON_WITH_ADDRESS_PREFILL_ID = "#bwa-checkout-button-address-prefill-widget";
var QUICK_CHECKOUT_SELECT_ANOTHER_ADDRESS_ID = exports.QUICK_CHECKOUT_SELECT_ANOTHER_ADDRESS_ID = "bwa-qc-select-another-widget";
var EMBEDDED_CHECKOUT_IMPORT_ADDRESS_WIDGET_ID = exports.EMBEDDED_CHECKOUT_IMPORT_ADDRESS_WIDGET_ID = "bwa-embedded-checkout-import-address-widget";
//# sourceMappingURL=constants.js.map
